import { Skeleton } from 'antd';
import { SectionSummaryPanel } from './components';
import { useSubmissionSectionSummaryV3 } from './hooks';
import { OverviewHeader, OverviewProgress, SummaryCard } from './submission-section-summary-v3.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SubmissionSectionSummaryV3 = function SubmissionSectionSummaryV3(props) {
  var sectionSummaries = props.sectionSummaries,
      label = props.label,
      isLoadingGetQuestions = props.isLoadingGetQuestions,
      hideOverviewHeader = props.hideOverviewHeader;

  var _useSubmissionSection = useSubmissionSectionSummaryV3(props),
      sectionItems = _useSubmissionSection.sectionItems,
      totalAnswered = _useSubmissionSection.totalAnswered,
      totalQuestions = _useSubmissionSection.totalQuestions,
      isCollapsible = _useSubmissionSection.isCollapsible,
      selectQuestion = _useSubmissionSection.selectQuestion,
      toggleSection = _useSubmissionSection.toggleSection;

  if (!sectionSummaries) {
    return /*#__PURE__*/_jsx(Skeleton, {
      paragraph: {
        rows: 10
      },
      active: true
    });
  }

  return /*#__PURE__*/_jsxs(SummaryCard, {
    children: [!hideOverviewHeader && /*#__PURE__*/_jsxs(OverviewHeader, {
      children: [/*#__PURE__*/_jsx("span", {
        children: label.overview
      }), /*#__PURE__*/_jsx(OverviewProgress, {
        children: "".concat(totalAnswered, "/").concat(totalQuestions)
      })]
    }), sectionItems.map(function (sectionItem) {
      return /*#__PURE__*/_jsx(SectionSummaryPanel, {
        sectionItem: sectionItem,
        isLoadingQuestions: isLoadingGetQuestions,
        isCollapsible: isCollapsible,
        label: label,
        onToggleSection: toggleSection,
        onSelectQuestion: selectQuestion
      }, sectionItem.id);
    })]
  });
};